import { parseSuccessResponse } from "@crown/data";
import { logError } from "@crown/logging";
import type { Event } from "./events";

/** A client-side handler that transports tracking events to the server. 
  * Requires track-resolver to be installed.
  * 
  * Set it up by doing 

    import { ALL, sendToServer } from '@crown/tracking';

    addHandlers({ [ALL]: sendToServer });
  */
export async function sendToServer(
  event: Event,
  endpoint = "/resources/track"
) {
  await parseSuccessResponse(
    await fetch(endpoint, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        ...event,
        // the server can figure these out from headers
        cookies: undefined,
        userAgent: undefined,
        clientIp: undefined,
      }),
    })
  ).catch((e) => {
    e.message = `While sending event to server: ${e.message}`;

    logError(e);
  });
}
